import Flex from '@Resources/styles/flex.scss';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import { Alert, IconButton, MenuItem, Tooltip } from '@mui/material';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { getNotificationSeverityString } from '@Data/notifications/Helpers';
import { NotificationSeverity } from '@Data/notifications/Interfaces';
import Styles from '../../Header.scss';

const NotificationItem = (props) => {
    const { severity, message, onCancel, closeText, closeIcon, hideIcon, id } =
        props;

    const severityStr: any = getNotificationSeverityString(severity);

    const icon = closeIcon ? closeIcon : <CloseIcon />;

    const action = !hideIcon ? (
        <Tooltip title={closeText}>
            <IconButton onClick={onCancel}>{icon}</IconButton>
        </Tooltip>
    ) : null;

    return (
        <MenuItem>
            <Alert
                id={id}
                variant="outlined"
                severity={severityStr}
                className={Styles.hNotificationItem}
                action={action}
                sx={{
                    '.MuiAlert-message': {
                        display: 'flex',
                        flexGrow: 1,
                    },
                    '.MuiAlert-action': {
                        padding: 0,
                    },
                }}
            >
                <div className={cx(Flex.flex, Flex.grow)}>{message}</div>
            </Alert>
        </MenuItem>
    );
};

NotificationItem.propTypes = {
    severity: PropTypes.oneOf([
        NotificationSeverity.ERROR,
        NotificationSeverity.INFO,
        NotificationSeverity.WARNING,
        NotificationSeverity.SUCCESS,
    ]),
    message: PropTypes.any,
    onCancel: PropTypes.func,
    closeText: PropTypes.string,
    closeIcon: PropTypes.any,
    hideIcon: PropTypes.bool,
    id: PropTypes.string,
};

NotificationItem.defaultProps = {
    closeText: 'Dismiss',
    closeIcon: null,
    hideIcon: false,
};

export default NotificationItem;
